function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  void 0 === t && void 0 !== window && (t = window), "function" == typeof define && define.amd ? define([], function () {
    return t.SPID = e();
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.SPID = e();
}(this, function () {
  var u = function () {
    "use strict";

    function t(t, e) {
      return ['<img aria-hidden="true"', 'src="', u.assetsBaseUrl, t, '.svg"', 'alt="', e, '" style="float:left" />'].join("");
    }

    function p(t, e) {
      return ['<input type="hidden" name="', t, '" value="', e, '" />'].join("");
    }

    function s(t, e) {
      this.config = t, this._providers = e;
    }

    var o;
    s.prototype.changeLanguage = function (t) {
      this.config.lang = t, this._render();
    }, s.prototype._showElement = function (t) {
      t.removeAttribute("hidden");
    }, s.prototype._hideElement = function (t) {
      var e = document.createAttribute("hidden");
      t.setAttributeNode(e);
    }, s.prototype._giveFocusTo = function (t) {
      var e = setInterval(function () {
        t.focus();
      }, 100);
      t.addEventListener("focus", function () {
        clearInterval(e);
      });
    }, s.prototype._handleEscKeyEvent = function (t) {
      27 === t.keyCode && this._hideProvidersPanel();
    }, s.prototype._showProvidersPanel = function () {
      var e = this;
      e._btn.classList.add("spid-button-transition"), e._showElement(e._wrapper), e._giveFocusTo(e._wrapper.querySelector(".spid-button-panel-select")), e._wrapper.querySelector(".spid-button-logo").classList.add("spid-button-fade-in-left"), e._wrapper.querySelector(".spid-button-close-button").classList.add("spid-button-fade-in-left"), e._wrapper.querySelector(".spid-button-panel-select").classList.add("spid-button-panel-anim"), e._btn.querySelector(".spid-button-icon").classList.add("spid-button-icon-animation"), e._btn.querySelector(".spid-button-icon").classList.add("in");

      var t = e._wrapper.querySelectorAll(".spid-button-idp"),
          i = 1.1;

      t.forEach(function (t) {
        t.classList.add("spid-button-idp-fade-in"), t.setAttribute("style", "animation-delay: " + i + "s"), i += .1;
      }), setTimeout(function () {
        e._btn.classList.remove("spid-button-transition"), e._wrapper.querySelector(".spid-button-logo").classList.remove("spid-button-fade-in-left"), e._wrapper.querySelector(".spid-button-close-button").classList.remove("spid-button-fade-in-left"), e._wrapper.querySelector(".spid-button-panel-select").classList.remove("spid-button-panel-anim"), t.forEach(function (t) {
          t.classList.remove("spid-button-idp-fade-in"), t.removeAttribute("style");
        });
      }, 2e3), o = function o(t) {
        e._handleEscKeyEvent(t);
      }, document.addEventListener("keyup", o);
    }, s.prototype._hideProvidersPanel = function () {
      var t = this;
      t._hideElement(t._wrapper), t._btn.querySelector(".spid-button-icon").classList.remove("in"), t._wrapper.querySelector(".spid-button-little-man-icon").classList.add("spid-button-logo-animation-out"), t._wrapper.querySelector(".spid-button-panel-select").classList.add("spid-button-panel-anim"), t._btn.classList.remove("spid-button-transition"), t._btn.classList.add("spid-button-reverse-enter-transition"), setTimeout(function () {
        t._btn.classList.remove("spid-button-reverse-enter-transition"), t._wrapper.querySelector(".spid-button-little-man-icon").classList.remove("spid-button-logo-animation-out");
      }, 2e3), document.removeEventListener("keyup", o), o = null;
    }, s.prototype._render = function () {
      var t,
          e,
          i = this,
          o = document.querySelector(i.config.selector);
      o ? (o.setAttribute("aria-live", "polite"), o.innerHTML = i._renderButton(), i._btn = o.querySelector(".spid-button"), i._btn.addEventListener("click", function (t) {
        i._showProvidersPanel();
      }), i._btn.querySelector(".spid-enter-container") || (t = u.stylesheetUrl, (e = document.createElement("link")).rel = "stylesheet", e.type = "text/css", e.href = t, document.head.appendChild(e), i._wrapper = document.createElement("section"), i._wrapper.classList.add("spid-enter-container"), i._hideElement(i._wrapper), o.insertBefore(i._wrapper, o.firstChild), i._wrapper.innerHTML = '<div class="spid-enter"></div>'), i._wrapper.querySelector(".spid-enter").innerHTML = i._renderProvidersChoiceModal(), i._wrapper.querySelector(".spid-button-panel-close-button").addEventListener("click", function (t) {
        i._hideProvidersPanel();
      }), i._wrapper.querySelector(".spid-cancel-access-button").addEventListener("click", function (t) {
        i._hideProvidersPanel();
      })) : console.warn("Nessun placeholder HTML trovato nella pagina per i pulsanti SPID.");
    }, s.prototype._getI18n = function (t, e) {
      var i = this.config.lang,
          i = u.i18n[i] && u.i18n[i][t];
      return void 0 !== e && (i = i.replace(/\{\d}/, e)), i || console.error("La chiave richiesta non è disponibile nella lingua selezionata:", locale, t), i || t;
    }, s.prototype._renderProvidersChoiceModal = function () {
      var e = this,
          i = "";
      return e._providers.forEach(function (t) {
        i += e._renderProviderButton(t);
      }), ['<section class="spid-button-panel spid-button-panel-select" aria-label="', e._getI18n("scegli_provider_SPID"), '" tabindex="0">', '<header class="spid-button-header">', '<div class="spid-button-panel-back">', '<div class="spid-button-logo spid-button-fade-out-left">', t("img/spid-logo", e._getI18n("alt_logo_SPID")), "</div>", '<div class="spid-button-close-button spid-button-fade-out-right">', '<button tabindex="0" class="spid-button-panel-close-button spid-button-navigable" aria-label="', e._getI18n("naviga_indietro"), '">', t("img/close", e._getI18n("naviga_indietro")), "</button>", "</div>", "</div>", "</header>", '<div class="spid-button-panel-content">', '<img class="spid-button-little-man-icon" src="', u.assetsBaseUrl, "img/spid-logo-animation-black.svg", '" alt="', e._getI18n("entra_con_SPID"), '"></img>', '<div class="spid-button-panel-content-center">', '<h1 class="spid-enter-title-page spid-button-fade-in-bottom spid-button-fade-out-bottom">', e._getI18n("scegli_provider_SPID"), "</h1>", '<div class="spid-idp-list">', i, "</div>", '<div class="spid-non-hai-spid">', e._getI18n("non_hai_SPID"), ' <a href="https://www.spid.gov.it/richiedi-spid" target="_blank">', e._getI18n("scopri_di_piu"), "</a>", "</div>", "</div>", '<div class="spid-foot-btn">', '<button class="spid-cancel-access-button">', e._getI18n("annulla_accesso"), "</button>", "</div>", "</div>", "</section>"].join("");
    }, s.prototype._renderProviderButton = function (e) {
      var t = this,
          i = !1;
      t.config.extraProviders.forEach(function (t) {
        e.entityID == t.entityID && (i = !0);
      });
      var o = -1 < t.config.supported.indexOf(e.entityID) && -1 < e.protocols.indexOf(t.config.protocol) && (0 == t.config.extraProviders.length || i) && !1 !== e.active,
          n = o ? t._getI18n("accedi_con_idp", e.entityName) : t._getI18n("idp_disabled"),
          s = e.entityID in t.config.mapping ? t.config.mapping[e.entityID] : e.entityID,
          r = t.config.url.replace("{{idp}}", encodeURIComponent(s)),
          a = (e.logo ? ['<img src="', u.assetsBaseUrl, "img/idp-logos/", e.logo, '" alt="', e.entityName, '">'] : ["<span>", e.entityName, "</span>"]).join("");

      if ("POST" === t.config.method) {
        var d,
            l = p(t.config.fieldName, s);

        for (d in t.config.extraFields) {
          l += p(d, t.config.extraFields[d]);
        }

        return ['<span class="spid-button-idp">', '<form action="', r, '" method="POST">', '<button type="submit"', 'class="spid-button-idp-button"', 'title="', n, '"', o ? "" : "disabled", ">", a, "</button>", l, "</form>", "</span>"].join("");
      }

      if ("GET" === t.config.method) return ['<span class="spid-button-idp">', '<a title="', n, '" href="', r, '"', o ? "" : "disabled", ">", a, "</a>", "</span>"].join("");
    };
    var r = {
      lang: "it",
      method: "GET",
      fieldName: "idp",
      extraFields: {},
      selector: "#spid-button",
      mapping: {},
      extraProviders: [],
      protocol: "SAML",
      size: "medium",
      colorScheme: "positive",
      fluid: !(s.prototype._renderButton = function () {
        var t = this,
            e = t.config.fluid ? " spid-button-fluid " : "",
            i = "negative" == t.config.colorScheme ? "img/spid-ico-circle-lb.svg" : "img/spid-ico-circle-bb.svg";
        return ['<button class="spid-button spid-button-', t.config.colorScheme, " spid-button-", t.config.cornerStyle, " spid-button-size-", t.config.size, e, '" hidden>', '<span aria-hidden="true" class="spid-button-icon">', '<img src="', u.assetsBaseUrl, i, '" alt="', t._getI18n("entra_con_SPID"), '" />', "</span>", '<span class="spid-button-text">', t._getI18n("entra_con_SPID"), "</span>", "</button>"].join("");
      }),
      cornerStyle: "rounded"
    },
        a = ["small", "medium", "large"],
        d = ["positive", "negative"],
        l = ["rounded", "sharp"],
        c = [!0, !1];
    return {
      init: function init(e) {
        var t;
        if ("object" != _typeof(e) || null === e) t = "Non è stata fornita la configurazione";else {
          for (var i in e = JSON.parse(JSON.stringify(e)), r) {
            i in e || (e[i] = r[i]);
          }

          e.url ? "GET" == e.method && -1 === e.url.indexOf("{{idp}}") ? t = "L'url non contiene il placeholder {{idp}}" : -1 === a.indexOf(e.size) ? t = "Le dimensioni supportate sono " + a + "; valore non valido:" + e.size : -1 === d.indexOf(e.colorScheme) ? t = "I colori supportati sono " + d + "; valore non valido:" + e.colorScheme : -1 === l.indexOf(e.cornerStyle) ? t = "Il valori supportati per il parametro cornerStyle sono " + l + "; valore non valido:" + e.cornerStyle : -1 === c.indexOf(e.fluid) && (t = "I valori supportati per il parametro fluid sono " + c + "; valore non valido:" + e.fluid) : t = "Non è stato fornito l'url obbligatorio in configurazione";
        }

        if (!t) {
          var o = JSON.parse(JSON.stringify(u.providers));
          e.extraProviders.forEach(function (t) {
            "protocols" in t || (t.protocols = ["SAML"]), o.push(t), e.supported.push(t.entityID);
          });
          var n = new s(e, o);
          return n._render(), n;
        }

        console.error(t);
      }
    };
  }();

  return u.i18n = {
    it: {
      naviga_indietro: "Torna indietro",
      alt_logo_SPID: "Logo SPID",
      scegli_provider_SPID: "Scegli il tuo provider SPID",
      annulla_accesso: "Annulla",
      non_hai_SPID: "Non hai SPID?",
      cosa_SPID: "Cos'è SPID?",
      entra_con_SPID: "Entra con SPID",
      scopri_di_piu: "Scopri di più.",
      accedi_con_idp: "Accedi a SPID con {0}",
      idp_disabled: "Provider non attivo"
    },
    en: {
      naviga_indietro: "Go back",
      alt_logo_SPID: "SPID logo",
      scegli_provider_SPID: "Choose your SPID provider",
      annulla_accesso: "Cancel",
      non_hai_SPID: "Don't have SPID?",
      cosa_SPID: "What is SPID?",
      entra_con_SPID: "Sign in with SPID",
      scopri_di_piu: "Learn more.",
      accedi_con_idp: "Access to SPID with {0}",
      idp_disabled: "Provider not enabled"
    },
    de: {
      naviga_indietro: "Gehen Sie zurück",
      alt_logo_SPID: "SPID Logo",
      scegli_provider_SPID: "Wähle Ihren SPIDProvider",
      annulla_accesso: "Zurücknehmen",
      non_hai_SPID: "Haben Sie nicht SPID?",
      cosa_SPID: "Was ist SPID?",
      entra_con_SPID: "Loggen Sie mit SPID",
      scopri_di_piu: "Finde mehr heraus.",
      accedi_con_idp: "Zugriff auf SPID mit {0}",
      idp_disabled: "Provider nicht aktiviert"
    }
  }, u.providers = [{
    protocols: ["SAML"],
    entityName: "Aruba ID",
    logo: "spid-idp-arubaid.svg",
    entityID: "https://loginspid.aruba.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Infocert ",
    logo: "spid-idp-infocertid.svg",
    entityID: "https://identity.infocert.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Poste ID",
    logo: "spid-idp-posteid.svg",
    entityID: "https://posteid.poste.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Sielte",
    logo: "spid-idp-sielteid.svg",
    entityID: "https://identity.sieltecloud.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Tim ID",
    logo: "spid-idp-timid.svg",
    entityID: "https://login.id.tim.it/affwebservices/public/saml2sso",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Namirial ID",
    logo: "spid-idp-namirialid.svg",
    entityID: "https://idp.namirialtsp.com/idp",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "SPIDItalia Register.it",
    logo: "spid-idp-spiditalia.svg",
    entityID: "https://spid.register.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Intesa ID",
    logo: "spid-idp-intesaid.svg",
    entityID: "https://spid.intesa.it",
    active: !0
  }, {
    protocols: ["SAML"],
    entityName: "Lepida ID",
    logo: "spid-idp-lepidaid.svg",
    entityID: "https://id.lepida.it/idp/shibboleth",
    active: !0
  }], u.assetsBaseUrl = "https://italia.github.io/spid-smart-button/", u.stylesheetUrl = "https://italia.github.io/spid-smart-button/spid-button.min.css", u;
});